import '@/js/dist/www.iichi.com/common';

import { createApp, h } from 'vue';
import { uniq } from '@/js/lib/helper/array';
import { pinia } from '@/js/lib/store';
import { useItemStore } from '@/js/lib/store/item';
import LikeButtonSmall from '@/js/components/www.iichi.com/organisms/likeButtonSmall.vue';

const itemStore = useItemStore(pinia);

document.addEventListener('DOMContentLoaded', async () => {
  const likeButtonEls: NodeListOf<HTMLElement> = document.querySelectorAll('like-button-small');
  if (likeButtonEls.length > 0) {
    const itemIds = Array.from(likeButtonEls, (el) => Number(el.dataset.itemId));
    itemStore.initLikedData(uniq(itemIds));

    likeButtonEls.forEach((el) => {
      createApp({
        render: () =>
          h(LikeButtonSmall, {
            itemId: Number(el.dataset.itemId),
          }),
      }).mount(el);
    });
  }
});
